import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center py-2 border-b last:border-b-0"
};
const _hoisted_2 = {
  class: "flex flex-col grow"
};
const _hoisted_3 = {
  class: "inline-flex text-white text-xs bg-blue-500 px-2 rounded-xl mr-1"
};
const _hoisted_4 = {
  key: 0,
  class: "inline-flex"
};
const _hoisted_5 = {
  class: "inline-flex text-white text-xs bg-green-500 px-2 rounded-xl mr-1"
};
const _hoisted_6 = {
  class: "inline-flex text-white text-xs bg-amber-500 px-2 rounded-xl"
};
import { app } from "@/di";
import { StaffNegotiationStarter } from "@/modules/staff/services/StaffNegotiationStarter";
import { Team } from "@/modules/team/entity";
import { NegotiationStatusEnum } from "@/modules/diplomacy/enums";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Staff',
  props: {
    staffMember: null
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const negotiator = app.get(StaffNegotiationStarter);
    const team = ref(([__temp, __restore] = _withAsyncContext(() => Team.current()), __temp = await __temp, __restore(), __temp));
    const negotiation = ref();
    const refresh = async () => {
      negotiation.value = await negotiator.getNegotiation(team.value, props.staffMember);
    };
    ;
    [__temp, __restore] = _withAsyncContext(() => refresh()), await __temp, __restore();
    const router = useRouter();
    const negotiate = async staffMember => {
      const negotiation = await negotiator.start(team.value, staffMember);
      await router.push({
        name: 'negotiations.show',
        params: {
          id: negotiation.id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(EntityLink, {
        entity: __props.staffMember
      }, null, 8, ["entity"])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(__props.staffMember.constructor.name) + " ", 1), __props.staffMember.constructor.name === 'coach' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.staffMember.positionArea), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$money(__props.staffMember.marketValue)) + " " + _toDisplayString(_ctx.$t('once')), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$money(__props.staffMember.wage)) + " " + _toDisplayString(_ctx.$t('monthly')), 1)])]), _createElementVNode("div", null, [negotiation.value ? (_openBlock(), _createBlock(_component_NButton, {
        key: 0,
        size: "small",
        secondary: "",
        type: negotiation.value.status === _unref(NegotiationStatusEnum).OPENED ? 'success' : 'error',
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push({
          name: 'negotiations.show',
          params: negotiation.value
        }))
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.Handshake20Regular
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["type"])) : (_openBlock(), _createBlock(_component_NButton, {
        key: 1,
        secondary: "",
        size: "small",
        onClick: _cache[1] || (_cache[1] = $event => negotiate(__props.staffMember))
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.Handshake20Regular
        }, null, 8, ["icon"])]),
        _: 1
      }))])]);
    };
  }
});